import { Component, OnInit, Input, Renderer2, ElementRef, ChangeDetectorRef, PLATFORM_ID, Inject } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { DataLoginI } from 'src/app/interfaces/login/login.interface';
import { AuthService } from 'src/app/services/api/auth/auth.service';
import { ActivatedRoute } from '@angular/router';
import { CookieService } from '../../services/cookie.service';
import { environment } from 'src/environments/environment';
import { Token } from '@angular/compiler';
import { UserData } from 'src/app/interfaces/user/user.interface';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { isPlatformBrowser } from '@angular/common';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {

  recuperoForm: any;
  loginForm: any;
  callback: string | null;
  esIngresar: boolean = false;
  errorLogin: string = '';
  errorRecoverPassword: boolean = false;
  errorRecoverPasswordMessage: string | null = null;
  expiredLinkError: boolean = false;
  loginIn: boolean = false;
  recuperando: boolean = false;
  recuperado: boolean = false;
  logueandoApp: boolean = false;
  checkUser: boolean;
  userExist: boolean = true;
  completeProfile: boolean = false;
  cookieDomain:string = `${environment.COOKIE_DOMAIN}`;
  step: number = 1;
  showpass: boolean = false;
  preRegisteredData: UserData;
  @Input() isModal: boolean = false;

  constructor(
    private auth: AuthService,
    private formbuilder: FormBuilder,
    private route: Router,
    private activatedRoute: ActivatedRoute,
    private renderer: Renderer2,
    private cookieService: CookieService,
    private profileService: ProfileService,
    private cdr: ChangeDetectorRef,
    public authService: AuthService,
    private el: ElementRef,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.callback = this.activatedRoute.snapshot.queryParamMap.get('callback');

    this.loginForm = this.formbuilder.group({
      principal: new FormControl('', [Validators.required, Validators.email]),
      password: new FormControl('', [Validators.required]),
    });

    this.recuperoForm = this.formbuilder.group({
      passwordRecupero: new FormControl('', [Validators.required]),
      registerTerminosCondiciones: new FormControl('', [Validators.required]),
    });
  }

  ngOnInit(): void {  
    if (isPlatformBrowser(this.platformId)) {
      document.addEventListener(
        'changePassword',
        (e: Event) => {
          document
            .getElementsByClassName('modal-recupero')[0]
          .classList.add('visible');
        document.getElementsByTagName('body')[0].classList.add('noScroll');
      },
      false
    );

    document.addEventListener(
      'recuperarPassword',
      (e: Event) => {
        document
          .getElementsByClassName('modal-login')[0]
          .classList.add('visible');
        document.getElementsByTagName('body')[0].classList.add('noScroll');
        this.recuperando = true;
      },
      false
    );
    }

    if (this.activatedRoute.snapshot.routeConfig?.path == 'login-app') {
      this.activatedRoute.queryParams.subscribe((params: any) => {
        if (params.token) {
          this.logueandoApp = true;
          this.loginApp(params.token);
        }
      });
    }

    if (this.activatedRoute.snapshot.routeConfig?.path == 'login-web') {
      this.activatedRoute.queryParams.subscribe((params: any) => {
        if (params.token) {
          this.logueandoApp = true;
          this.loginAppWeb(params.token, params.url);
        }
      });
    }

    if (isPlatformBrowser(this.platformId)) {
      document.addEventListener(
        'ingresar',
        (e: Event) => {
          this.openLogin();
          this.esIngresar = true;
        },
        false
      );
    }

    this.loginForm.get('principal')?.valueChanges.subscribe((value: any) => {
      if (!value) {
        this.errorRecoverPassword = false;
      }
    });
    this.profileService.profile$.subscribe(data => {
      this.completeProfile = data.completeProfile;
      this.preRegisteredData = data.preRegisteredData;
    });
    this.recuperoForm.get('passwordRecupero')?.valueChanges.subscribe(() => {
      if (this.errorRecoverPasswordMessage) {
        this.errorRecoverPasswordMessage = null;
      }
    });
  }

  checkTerms() {
    if (!this.recuperoForm.get('registerTerminosCondiciones').value)
      this.recuperoForm
        .get('registerTerminosCondiciones')
        .setErrors({ error: true });
    else this.recuperoForm.get('registerTerminosCondiciones').setErrors(null);
  }

  initialLogin() {
    this.loginIn = false;
    this.recuperando = false;
    this.recuperado = false;
    this.errorRecoverPassword = false;
    this.step = 1;
    this.completeProfile = false;
  }

  deleteErrors() {
    this.errorLogin = '';
  }

  openLogin() {
    this.initialLogin();

    if (isPlatformBrowser(this.platformId)) {
      document.getElementsByClassName('modal-login')[0].classList.add('visible');
      document.getElementsByTagName('body')[0].classList.add('noScroll');
    }
  }

  initialState() {
    if (isPlatformBrowser(this.platformId)) {
      document.location.href = '/ingresar';
    }
  }

  areFieldsComplete(): boolean {
    return this.loginForm.get('principal')?.value && this.loginForm.get('password')?.value;
  }

  areRecoveryFieldsComplete(): boolean {
    return this.loginForm.get('principal')?.value;
  }

  validatePassword(): void {
    if (
      !this.validatePasswordRequirements(
        this.recuperoForm.get('passwordRecupero').value
      )
    ) {
      this.recuperoForm.get('passwordRecupero').setErrors({ error: true });
    } else {
      this.recuperoForm.get('passwordRecupero').setErrors(null);
    }
  }

  validatePasswordRequirements(password: any) {
    const regExp = new RegExp(
      /(?=(.*[0-9]))(?=.*[\!@#$%^&*()\\[\]{}\-_+=~`|:;"'<>,./?])(?=.*[a-z])(?=(.*[A-Z]))(?=(.*)).{8,}/
    );
    const valid = regExp.test(password);

    return valid;
  }

  recupero() {
    this.recuperando = true;
  }

  recuperarPassword() {
    this.errorRecoverPassword = false;
    var tthis = this;

    const dynamicElement = this.el.nativeElement.querySelector('#id_not_ok_recover');

    if (dynamicElement && dynamicElement.parentNode) {
      this.renderer.removeChild(dynamicElement.parentNode, dynamicElement);
    }

    const dynamicElement1 = this.el.nativeElement.querySelector('#id_not_ok_login');

    if (dynamicElement1 && dynamicElement1.parentNode) {
      this.renderer.removeChild(dynamicElement1.parentNode, dynamicElement1);
    }

    this.auth
      .passwordRecover(this.loginForm.get('principal')?.value)
      .subscribe({
        next: (data: any) => {
          tthis.recuperado = true;
        },
        error: (err: any) => {
          if (err) {
            this.errorRecoverPassword = true;
          } else {
            this.errorRecoverPassword = false;
          }
        },
      });
  }

  recuperarPassword2() {
    this.errorRecoverPasswordMessage = null;
    this.errorRecoverPassword = false;
    this.expiredLinkError = false;
    this.activatedRoute.queryParams.subscribe((params: any) => {
      this.auth
        .passwordRecover2(
          params.principal,
          this.recuperoForm.get('passwordRecupero')?.value,
          params.token
        )
        .subscribe(
          () => {
            this.recuperado = true;
          },
          (err: any) => {
            const mensaje = err?.error?.message || 'Ocurrió un error inesperado. Intenta nuevamente.';
  
            if (mensaje === 'No se logro efectuar el cambio de constraseña.') {
              this.expiredLinkError = true;
              this.errorRecoverPasswordMessage = 'El enlace ha expirado, intenta solicitar uno nuevo.';
  
              if (isPlatformBrowser(this.platformId)) {
                setTimeout(() => {
                  document
                    .getElementsByClassName('modal-recupero')[0]
                    .classList.remove('visible');
                  this.openLogin();
                  this.recuperando = true;
                  this.expiredLinkError = false;
                }, 3000);
              }
            } else {
              this.errorRecoverPasswordMessage = mensaje;
            }
          }
        );
    });
  }

  noRecupero() {
    this.initialLogin();
  }

  closeLogin() {
    if (isPlatformBrowser(this.platformId)) {
      document.getElementsByTagName('body')[0].classList.remove('noScroll');
      document
        .getElementsByClassName('modal-login')[0]
        .classList.remove('visible');
    }
  }

  registro() {
    this.closeLogin();
    if (isPlatformBrowser(this.platformId)) {
      document
        .getElementsByClassName('modal-register')[0]
        .classList.add('visible');
      document.getElementsByTagName('body')[0].classList.add('noScroll');
    }
  }

  onLoginSuccess(): void {
    this.authService.IsLoggedIn().then(() => {
      const redirectUrl = sessionStorage.getItem('redirectUrl');
      this.route.navigateByUrl(redirectUrl || '/');
      sessionStorage.removeItem('redirectUrl');
    });
  }

  onLogin(form: DataLoginI): void {
    let tthis = this;
    this.loginIn = true;
    tthis.errorLogin = '';
    const currentUrl = this.route.routerState.snapshot.url;

    const dynamicElement = this.el.nativeElement.querySelector('#id_not_ok_login');

    if (dynamicElement && dynamicElement.parentNode) {
      this.renderer.removeChild(dynamicElement.parentNode, dynamicElement);
    }

    const dynamicElement2 = this.el.nativeElement.querySelector('#id_not_ok_recover');

    if (dynamicElement2 && dynamicElement2.parentNode) {
      this.renderer.removeChild(dynamicElement2.parentNode, dynamicElement2);
    }

    this.auth.login(form).subscribe({
      next: (data: any) => {
        tthis.loginIn = false;
        if(data.login.access_token)
        {
          const fechaActual = new Date();
          // Sumarle 2 horas a la fecha actual para obtener la fecha de expiración
          const fechaExpiracion = new Date(fechaActual.getTime() + (2 * 60 * 60 * 1000)); // 2 horas en milisegundos

          this.cookieService.setCookie('token', data.login.access_token, fechaExpiracion, this.cookieDomain);
        }

        if (
          data.login &&
          data.login.access_token &&
          tthis.callback &&
          atob(tthis.callback)
        ) {
          //User logueado y callback
          var link = atob(tthis.callback);
          var paramChar = '?';
          if (link.indexOf('?') == -1) paramChar = '?';
          else paramChar = '&';
          if(isPlatformBrowser(this.platformId)) {
            document.location.href =
              atob(tthis.callback);
          }
        } else if (data.login && data.login.access_token) {
          //user logueado
          if (!tthis.isModal) this.route.navigate(['home']);
          else if (tthis.isModal) this.closeLogin();
          this.route.navigateByUrl(currentUrl).then(() => {
            if(this.esIngresar)
              this.onLoginSuccess();
            else
                window.location.reload();
          });
        } else {
          // tthis.errorLogin = data.toString();
        }
      },
      error: (error: any) => {
        tthis.loginIn = false;
        tthis.errorLogin = error.error.message;
        const spanElement = this.renderer.createElement('span');
        this.renderer.setAttribute(spanElement, 'id', 'id_not_ok_login');
        this.renderer.appendChild(this.el.nativeElement, spanElement);
      },
    });
  }

  checkUserStatus(form: DataLoginI): void {
    this.loginIn = true;
    this.errorLogin = '';
    this.recuperado = false;
    this.checkUser = false;
    this.userExist = true;
    this.removeErrorMessages();
  
    this.auth.checkUserAccount(form.principal).subscribe(
      (res) => {
        this.handleUserResponse(res);
        this.loginIn = false;
      },
      (error) => {
        console.error('Error validating user:', error);
        this.checkUser = false;
        this.loginIn = false;
        this.handleUserResponse(error.error || "");
      }
    );
  }
  
  private removeErrorMessages(): void {
    const elementsToRemove = ['#id_not_ok_login', '#id_not_ok_recover'];
  
    elementsToRemove.forEach(selector => {
      const dynamicElement = this.el.nativeElement.querySelector(selector);
      if (dynamicElement && dynamicElement.parentNode) {
        this.renderer.removeChild(dynamicElement.parentNode, dynamicElement);
      }
    });
  }
  
  handleUserResponse(response: any): void {
    if (typeof response === 'string' && response.trim() === "Usuario no encontrado!") {
        this.handleUserNotFound();
        return;
    }
    try {
        const user = JSON.parse(response);
        const status = user.status;
      
        if (status === "Registrado!") {
            this.checkUser = true;
            this.userExist = true;
            this.completeProfile = false;
            this.step = 2;
        } else if (status === "Pre-Registrado!") {
            this.completeProfile = true;
            this.preRegisteredData = user.thalamusResponse;
        } else {
            this.handleUserNotFound();
        }
    } catch (error) {
        console.error('Error al analizar la respuesta del usuario:', error);
        this.handleUserNotFound();
    }
  }

  private handleUserNotFound(): void {
    this.checkUser = false;
    this.completeProfile = false;
    this.userExist = false;
    this.step = 1;
  }

  loginApp(token: string): void {
    let tthis = this;
    this.loginIn = true;
    tthis.errorLogin = '';
    this.auth.loginApp(token).subscribe({
      next: (data: any) => {
        tthis.loginIn = false;
        // tthis.logueandoApp = false;
        this.errorLogin = `${token}`;
        //window.open(`${environment.URL_MKTPLACE}?token=${data.login.access_token}`, "_self");
      },
      error: (error: any) => {
        tthis.loginIn = false;
        tthis.errorLogin = error.error.message;
        // tthis.logueandoApp = false;
        if (isPlatformBrowser(this.platformId)) {
          document.location.href = `${environment.URL_MKTPLACE}?token=` + 11;
          this.route.navigateByUrl('/');
        }
      },
    });
  }

  loginAppWeb(token: string, url = '/'): void {
    let tthis = this;
    this.loginIn = true;
    tthis.errorLogin = '';
    this.auth.loginApp(token).subscribe({
      next: (data: any) => {
        tthis.loginIn = false;
        tthis.logueandoApp = false;
        if(url != '/')
          this.route.navigateByUrl( atob( url ) );
        else
          this.route.navigateByUrl( url );
      },
      error: (error: any) => {
        tthis.loginIn = false;
        tthis.errorLogin = error.error.message;
        tthis.logueandoApp = false;
      },
    });
  }

  public inputsErros(controlName: string): any {
    let error = null;
    const control = this.loginForm.get(controlName);
    if (control?.touched && control.errors != null) {
      if (control.errors) {
        error = 'El campo' + controlName + 'es requerido';
      }
    }
    return error;
  }
}
